<template>
    <div class="modal fade" :id="'employer-'+type+'-modal'" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div v-if="!isMeetingNotesOpened" class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" id="myModalLabel">
                        {{ type === 'note' ? 'Employer Notes' : 'Health Score' }}
                    </h4>
                </div>
                <div class="modal-body">
                    <div v-loading="loading">
                        <textarea class="form-control" v-model="note"></textarea>

                        <div class="form-check">
                          <input type="checkbox"
                                 class="form-check-input"
                                 id="is-channel-message"
                                 v-model="isChannelMessage"
                          />
                          <label class="form-check-label" for="is-channel-message">@channel</label>
                        </div>

                        <div class="row" style="margin: 10px 0">
                            <btn v-if="!editing" :click="addNote" icon="fas fa-plus">Add {{ type | capitalize }}</btn>
                            <btn v-if="!editing && type === 'note'" :click="openMeetingNotes" icon="fas fa-phone">Meeting Notes</btn>
                            <btn v-if="editing" :click="saveNote" icon="fas fa-pencil">Save {{ type | capitalize }}</btn>
                            <btn v-if="editing" :click="clearNote" icon="fas fa-times">Cancel</btn>
                        </div>

                        <div class="employer-notes" v-if="data">
                            <template v-for="item in data.notes">
                                <div class="employer-note">
                                    <div class="employer-note-content"><div v-if="item.is_pinned"><i class="fas fa-thumbtack"></i> Pinned</div>{{ item.text }}</div>
                                    <div class="employer-note-footer">
                                        {{ item.created_by }} · {{ item.created_at }} · <a href="#" @click.prevent="editNote(item)">edit</a>
                                        <template v-if="!item.is_pinned">
                                        · <a href="#" @click.prevent="pinNote(item)">pin</a>
                                        </template>
                                        <template v-if="item.is_pinned">
                                        · <a href="#" @click.prevent="unpinNote(item)">unpin</a>
                                        </template>
                                        · <a href="#" @click.prevent="removeNote(item)">delete</a>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="modal-footer" style="text-align: center">
                    <button type="button" class="btn" data-dismiss="modal">Close</button>
                </div>
            </div>
            <div v-else class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" id="myModalLabel">
                        Meeting Notes
                    </h4>
                </div>
                <div class="modal-body">
                    <div v-loading="loading">
                        <div class="row" style="padding:15px;">
                            <textarea class="form-control" v-model="meeting_note" rows="60"></textarea>
                        </div>
                    </div>
                </div>
                <div class="modal-footer" style="text-align: center">
                    <btn :click="closeMeetingNotes" icon="fas fa-step-backward">Cancel</btn>
                    <btn :click="saveMeetingNotes" icon="fas fa-save">Save</btn>
                    <button type="button" class="btn" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
        props: [
            'employer_id',
            'type',
        ],
        data() {
            return {
                employerId: this.employer_id,
                data: null,
                loading: true,
                note: '',
                meeting_note: '',
                isChannelMessage: this.defaultIsChannelMessage(),
                editing: false,
                isMeetingNotesOpened: false,
            };
        },
        filters: {
            capitalize(value) {
                if (!value) return '';
                value = value.toString();
                return value.charAt(0).toUpperCase() + value.slice(1);
            }
        },
        methods: {
            refresh() {
                this.loading = true;
                return axios.get(url(`admin/employer/${this.employerId}/${this.type}/list`))
                    .then(response => {
                        this.data = response.data
                        this.loading = false;
                        this.editing = false;
                    });
            },
            addNote() {
                return axios.post(url(`admin/employer/${this.employerId}/${this.type}/add`), {
                    text: this.note,
                    isChannelMessage: this.isChannelMessage
                }).then(response => {
                    this.note = '';
                    this.isChannelMessage = this.defaultIsChannelMessage();
                    this.refresh();
                });
            },
            editNote(note) {
                return axios.get(url(`admin/employer/${this.employerId}/${this.type}/${note.id}/get`))
                    .then(response => {
                        this.editing = response.data;
                        this.note = this.editing.text;
                    });
            },
            saveNote() {
                return axios.post(url(`admin/employer/${this.employerId}/${this.type}/${this.editing.id}/save`), {
                        text: this.note,
                        isChannelMessage: this.isChannelMessage
                    }).then(response => {
                        this.note = '';
                        this.isChannelMessage = this.defaultIsChannelMessage();
                        this.refresh();
                    });
            },
            clearNote() {
                this.note = '';
                this.isChannelMessage = this.defaultIsChannelMessage();
                this.editing = false;
            },
            removeNote(note) {
                return axios.post(url(`admin/employer/${this.employerId}/${this.type}/${note.id}/remove`))
                    .then(response => {
                        this.refresh();
                    });
            },
            pinNote(note) {
                return axios.post(url(`admin/employer/${this.employerId}/${this.type}/${note.id}/pin`))
                    .then(response => {
                        window.location.reload();
                    });
            },
            unpinNote(note) {
                return axios.post(url(`admin/employer/${this.employerId}/${this.type}/${note.id}/unpin`))
                    .then(response => {
                        window.location.reload();
                    });
            },
            defaultIsChannelMessage() {
                return this.type === 'note' ? false : true;
            },
            showModalFor(employerId) {
                this.employerId = employerId;
                this.closeMeetingNotes();
                $("#employer-"+this.type+"-modal").modal();
                this.refresh();
            },
            openMeetingNotes() {
                this.meeting_note = `
Attendees:


Date of Last overall check in:


Frequency of overall client info check:


General check-in on how client is doing (personal/company):
How is current volume/lead quality?
Current hiring goals:
Goals for the upcoming months:
Number of recruiters:
Total hires:
CPH:
CPL:
LPH:
What metric is most important to the client for decision-making?


Other Vendors and if so, how many?


How do we (TR) compare to their other vendors?


All Ads running with TR, why not?


Lead/Hire Status Report: Do we have this/need to request this?


Overall Advertising budget?
How much is allocated for TR?
Can we get more budget from them?


No-cost incentives covered/utilized:
Protect Your Hires (PYH) program
Review Generation Template
JA competitor analysis


Any additional feedback or concerns from client:


Any previous topics to cover from past check-ins:


Post-meeting plan:

`;
                this.isMeetingNotesOpened = true;
            },
            closeMeetingNotes() {
                this.isMeetingNotesOpened = false;
            },
            saveMeetingNotes() {
                this.loading = true;
                this.note = this.meeting_note;
                this.addNote().then(response => {
                    this.closeMeetingNotes();
                    this.meeting_note = '';
                });
            }
        },
        mounted() {
            if (this.employerId) {
                let self = this;
                $(".employer-"+this.type+"-button").show().click(function() {
                    self.showModalFor(self.employerId);
                    return false;
                });
            }
        }
    }
</script>

<style>
.employer-notes {
}

.employer-note {
    padding: 15px 0;
    border-bottom: 1px solid #ccc;
}

.employer-note-footer {
    color: #666;
}

.employer-note-content {
    font-weight: bold;
    white-space: pre-line;
}

.call-template-p {
    font-weight: bold;
    font-size: 1.7rem;
    line-height: 3rem;
    margin: 0 0 60px !important;
}
</style>
